import { render, staticRenderFns } from "./ServiceStatus.vue?vue&type=template&id=36dc77a3&scoped=true"
import script from "./ServiceStatus.vue?vue&type=script&lang=js"
export * from "./ServiceStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dc77a3",
  null
  
)

export default component.exports